<template>
    <Message v-if="message || $slots.default" :severity="severity" :closable="closable" :icon="icon" :pt="pt">
        <div v-if="message" v-html="message"></div>
        <slot></slot>
    </Message>
</template>
<script>
import Message from "primevue/message";

export default {
    name: "AdaptersMessage",
    props: {
        message: {
            type: String,
            required: false,
            default: null,
        },
        severity: {
            type: String,
            required: false,
            default: 'error',
        },
        closable: {
            type: Boolean,
            required: false,
            default: false,
        },
        icon: {
            type: String,
            required: false,
            default: ''
        },
        pt: {
            type: Object,
            required: false,
            default: null,
        },
    },
    components: {
        Message,
    },
}
</script>

<style scoped>
/* скрываем отображение иконки компонента */
:deep(.p-message-icon) {
    display: none;
}
</style>
